import { useFormikSubmit } from "@certn/api";
import { ThemeContext } from "@certn/cascadia";
import {
  ButtonGroup,
  Grid,
  GridItem,
  PrimaryButton,
  Radio,
  RadioGroupFormikField,
} from "@certn/cascadia-react";
import { Field, Form, Formik, FormikHelpers } from "formik";
import { useContext, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { SettingsEditItem } from "../../../components/settings-edit/SettingsEditItem";

export function Appearance() {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded((curr) => !curr);
  const { theme, setTheme } = useContext(ThemeContext);
  const { submit } = useFormikSubmit(
    "/api/internal/applicant/me/preferences/appearance/update/",
    {
      onSuccess: toggle,
      showToastOnError: true,
    }
  );

  return (
    <SettingsEditItem
      setting={t("Appearance")}
      value={
        theme === "light"
          ? t("Light mode")
          : theme === "system"
            ? t("System setting")
            : t("Dark mode")
      }
      description={t("Choose a theme setting for your Certn account")}
      expanded={expanded}
      toggle={toggle}
      testID={expanded ? "appearance-cancel-link" : "appearance-edit-link"}
    >
      <Formik
        initialValues={{ mode: theme }}
        onSubmit={({ mode }, helpers) =>
          submit(
            { theme: mode.toUpperCase() },
            helpers as unknown as FormikHelpers<{ theme: string }>
          )
        }
      >
        <Form>
          <Grid width="316px">
            <GridItem>
              <Field
                name="mode"
                as={RadioGroupFormikField}
                isRequired
                aria-label={t("Language")}
                onChange={(theme: "light" | "dark") => setTheme(theme)}
              >
                <Radio
                  isCard
                  value="light"
                  testID="appearance-light-radio-button"
                >
                  <Trans>Light mode</Trans>
                </Radio>
                <Radio
                  isCard
                  value="dark"
                  testID="appearance-dark-radio-button"
                >
                  <Trans>Dark mode</Trans>
                </Radio>
              </Field>
            </GridItem>
            <GridItem>
              <ButtonGroup>
                <PrimaryButton
                  type="submit"
                  size="medium"
                  testID="appearance-save-button"
                >
                  {t("Save")}
                </PrimaryButton>
              </ButtonGroup>
            </GridItem>
          </Grid>
        </Form>
      </Formik>
    </SettingsEditItem>
  );
}
